import abnormalDetail from '@/pages/aftersale/abnormal-detail'
import aftersaleDetail from '@/pages/aftersale/aftersale-detail'
import afterSaleManage from '@/pages/aftersale/aftersale-manage'
import afterSaleInputTs from '@/pages/aftersale/aftersalse-input-ts'
import afterSaleShippingList from '@/pages/aftersale/aftersale-shipping-list'
import layout from '@/components/layout/layout'
import bigAftersaleRouter from './bigAftersaleRouter'
const afterSaleRouter =
{
  path: '/afterSale',
  component: layout,
  meta: {roles: ['shop', 'r4gys'], title: '售后管理', icon: 'icon-shouhouguanli'},
  children: [
    {
      path: '/afterSale/manage',
      component: afterSaleManage,
      name: 'afterSaleManage',
      meta: {roles: ['shop', 'r4gys'], title: '售后单'}
    },
    {
      path: '/afterSale/abnormal/detail',
      component: abnormalDetail,
      name: 'abnormalDetail',
      hidden: true,
      meta: {roles: ['shop', 'r4gys']}
    },
    {
      path: '/afterSale/shippingList',
      component: afterSaleShippingList,
      name: 'afterSaleShippingList',
      hidden: true,
      meta: {roles: ['shop', 'r4gys']}
    },
    {
      path: '/afterSale/detail',
      component: aftersaleDetail,
      hidden: true,
      name: 'afterSaleDetail',
      meta: {roles: ['shop', 'r4gys']}
    },
    {
      path: '/afterSale/afterSaleInputTs',
      component: afterSaleInputTs,
      hidden: true,
      name: 'afterSaleInputTs',
      meta: {roles: ['shop', 'r4gys']}
    },
    ...bigAftersaleRouter
  ]
}
export default afterSaleRouter



// WEBPACK FOOTER //
// ./src/router/modules/aftersaleRouter.js